import { Avatar, Tooltip } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { ExpenseTagColumn } from "~Components/expenseTagColumn"
import { useEmployee } from "~Shared/queries/employee.queries"
import { UserService } from "~Shared/services"
import { getNextApproverId } from "~Shared/utils/approvalProcess.utils"
import { getSubstitutionTooltipMessage } from "~Shared/utils/employee.utils"
import { IsServiceIcon } from "../icons/IsServiceIcon"
import { ShoppingBagIcon } from "../icons/ShoppingBagIcon"
import { PurchaseOrder } from "../types/PurchaseOrder.interfaces"

export const TodoTableNameField = ({ record }: { record: PurchaseOrder }) => {
    const loggedInProfile = UserService.getLoggedInEmployeeProfile()
    const { t } = useTranslation()
    const nextApproverId = getNextApproverId(record.approvalProcesses)
    const { data: approver, isLoading } = useEmployee(nextApproverId)
    if (!approver || isLoading) {
        return <></>
    }

    const substitutionTooltip = getSubstitutionTooltipMessage(approver, loggedInProfile.id, t)

    return (
        <div className="flex image-loader gap-10 flex-no-wrap items-center">
            <Avatar
                src={"#"}
                icon={record.isService ? <IsServiceIcon /> : <ShoppingBagIcon />}
                size={38}
                style={{
                    background: "rgba(111, 186, 255, 0.10)",
                }}
                className="flex-shrink-0 bg-[rgba(111,186,255,0.10)] flex rounded-full border-none justify-center items-center"
            />
            <div className="flex-1 overflow-hidden">
                <Tooltip title={substitutionTooltip}>
                    <span className={`font-bold text-15 text-[#181c32] truncate ${substitutionTooltip ? "p-3 rounded-sm bg-finway-blue bg-opacity-15" : ""}`}>
                        {`${approver.getFullName()}`} ({t("label:approver")})
                    </span>
                </Tooltip>
                <div className="flex">
                    <Tooltip title={record.purchaseOrderNumber}>
                        <div className="text-[#6B7280] text-sm leading-tight truncate font-normal w-full"># {record.purchaseOrderNumber}</div>
                    </Tooltip>

                    {record.tags ? (
                        <div className="mb-10 h-14">
                            <ExpenseTagColumn expenseTagIds={record.tags} />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
